import React, { useState } from 'react';
import CalSupportSavings from './CalSupportSavings';
import CalChurnRetention from './CalChurnRetention';
import './App.css';

function App(props) {
  const [currentCalc,setCurrentCalc] = useState(props?.calc??"SupportSavings");
  const showTabe = (props?.tab??"false") !== "false";

  return (
    <> 
      <ul className={"nav nav-tabs d-flex align-items-end justify-content-center mb-3"+(!showTabe?" d-none":"")}>
        <li className="nav-item">
          <a role="button" className={"nav-link ChurnRetention"+(currentCalc==="ChurnRetention"?" active":"")} onClick={(e)=>setCurrentCalc("ChurnRetention")}>Churn Reduction</a>
        </li>
        <li className="nav-item">
          <a role="button" className={"nav-link SupportSavings"+(currentCalc==="SupportSavings"?" active":"")} onClick={(e)=>setCurrentCalc("SupportSavings")}>Support Savings</a>
        </li>
      </ul>   

      <div className="row d-flex justify-content-center">
        {(() => {
          if (currentCalc==="SupportSavings") {
            return (
              <CalSupportSavings tickets={props.tickets} cost={props.cost}/>
            )
          }
        })()}

        {(() => {
          if (currentCalc==="ChurnRetention") {
            return (
              <CalChurnRetention tickets={props.tickets} cost={props.cost}/>
            )
          }
        })()}
      </div>
    </>
  );
}

export default App;
